/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAudioSpeakers: {
  name: 'audio-speakers';
  data: string;
} = {
  name: 'audio-speakers',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm14 0H6v16h12V4Zm-6 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm2 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" fill="currentColor"/></svg>`,
};
